import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../css/app.scss";
import CardList from "./CardListComponent";
import PopupJobDescription from "./PopupJobDescriptionComponent";
import PopupJobFormApplication from "./PopupJobFormApplicationComponent";
import "bootstrap/dist/css/bootstrap.css";
import Pagination from "../Pagination/Pagination";

const JobListComponent = ({ data }) => {
  const [isConnectedSuccess, setIsConnectedSuccess] = useState(false);
  const [jobList, setJobList] = useState([]);
  const [totalJobListings, setTotalJobListings] = useState(0);
  const [jobListingsRemaining, setJobListingsRemaining] = useState(0);
  const [placeholderValue, setPlaceholderValue] = useState(0);

  const [jobListLimit, setJobListLimit] = useState(12);
  const [searchQuery, setSearchQuery] = useState("");

  const [showModalJobDetails, setShowModalJobDetails] = useState(false);
  const [jobListDetails, setJobListDetails] = useState([]);

  const [activeIDCard, setActiveIDCard] = useState(false);

  const [showModalJobApplication, setShowModalJobApplication] = useState(false);

  const [recordsPerPage, setRecordsPerPage] = useState(6); // Default records per page

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchJobs(currentPage);
   
  }, [currentPage]);

 
  // useEffect(() => {
  //   // Adjust records per page based on window width
  //   const handleResize = () => {
  //     if (window.innerWidth <= 425) {
  //       setRecordsPerPage(5);
  //     } else {
  //       setRecordsPerPage(9);
  //     }
  //   };

  //   // Call handleResize initially and add event listener
  //   handleResize();
  //   window.addEventListener("resize", handleResize);

  //   // Remove event listener on cleanup
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  useEffect(() => {
    if (jobList.length > 0) {
      const alldetails = jobList.map((item) => getAllDetailJobList(item.adId));
      const resolvedDetails = Promise.all(alldetails);
      resolvedDetails.then((result) => {
        setJobListDetails(result);
      });
    }
  }, [jobList]);
 const fetchJobs = async (page = null) => {
    try {
      const offset = (page - 1) * jobListLimit;
      const params = {
        limit: jobListLimit,
        sortBy: "lastModified",
        sortOrder: "desc",
        action: "get_jobadder",
        nonce: react_ajax_object.ajax_react_nonce,
        offset: offset,
        endPoint: "jobboards/"+data.boardId+"/ads",
      };

      const response = await axios.get(react_ajax_object.ajax_react, {
        params: params,
      });
      const responseData = response.data;
      if (!responseData) {
        console.error("No data found in the response");
        return;
      }

      const totalCount = responseData.totalCount || 0;
      setTotalJobListings(totalCount);
      setIsConnectedSuccess(totalCount > 0);

      let jobItems = responseData.items || [];

      // Filter out draft, expired, and duplicates based on adId
      jobItems = jobItems.filter((item, index, self) => {
        return (
          item.state !== "Draft" &&
          item.state !== "Expired" &&
          index === self.findIndex((t) => t.adId === item.adId)
        );
      });

      // Calculate the number of job listings remaining
      const remaining = totalCount - jobItems.length;
      setJobListingsRemaining(remaining);

      setPlaceholderValue(totalCount - jobListLimit);

      // Update job list only if page is 1, else append to existing job list
      if (page === 1) {
        setJobList(jobItems);
        console.log(jobItems);
      } else {
        setJobList((prevJobList) => [...prevJobList, ...jobItems]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const toggleDetailJob = async () => {
    setShowModalJobDetails(!showModalJobDetails);
  };

  const toggleModalFormApplication = () => {
    setShowModalJobApplication(!showModalJobApplication);
  };

  const getAllDetailJobList = async (id) => {
    return await new Promise(async (resolve, reject) => {
      try {
        const params = {
          action: "get_jobadder",
          nonce: react_ajax_object.ajax_react_nonce,
          endPoint: "jobboards/"+data.boardId+"/ads/"+id,
          
        };

        const response = await axios.get(react_ajax_object.ajax_react, {
          params: params,
        });
        const responseData = response.data;
        if (!responseData) {
          resolve({
            status: "error",
            message: "No data found in the response",
            adId: id,
          });
          return;
        }

        setTimeout(resolve, Math.random() * 500, response?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        resolve({
          status: "error",
          message: "No data found in the response",
          jobads: id,
        });
      }
    });
  };
  // Calculate visible job list for current page
  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = Math.min(startIndex + recordsPerPage, jobList.length);
  const visibleJobList = jobList.slice(startIndex, endIndex);

  return (
    <div className="job-list-container">
      <PopupJobFormApplication
        jobListDetails={jobListDetails}
        activeID={activeIDCard}
        showModalForm={showModalJobApplication}
      />

      <PopupJobDescription
        showModalJob={showModalJobDetails}
        activeID={activeIDCard}
        jobListDetails={jobListDetails}
      />

      <h2
        className="job-list-title"
        style={{
          color: "#21419B",
          fontSize: "40px",
          fontWeight: "bold",
          alignItems: "center",
        }}
      >
        Open Positions
      </h2>
      <div className="list-container">
        <ul className="job-list">
          {visibleJobList.map((item, index) => (
            <CardList
              key={index}
              item={item}
              jobListDetails={jobListDetails}
              toggleModalFormApplication={toggleModalFormApplication}
              toggleModalDescription={toggleDetailJob}
              setActiveID={setActiveIDCard}
            />
          ))}
        </ul>
      </div>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={totalJobListings}
        pageSize={recordsPerPage}
        onPageChange={(page) => setCurrentPage(page)}
        jobList={jobList}
      />
    </div>
  );
};

export default JobListComponent;
